var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2325_10313)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#818D89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6.54058V11.6369C4.5 11.9142 4.70294 12.1389 4.98252 12.1389H12.9362C13.2155 12.1389 13.4187 11.9115 13.4187 11.6369V6.54058C13.4187 6.23632 13.237 6 12.9362 6H4.98252C4.67013 6 4.5 6.24213 4.5 6.54058ZM5.23336 6.98448C5.23336 6.86168 5.30768 6.79142 5.42642 6.79142C5.49987 6.79142 8.39003 8.62277 8.5651 8.73019L9.01742 9.01152C9.16084 8.91542 9.30484 8.83326 9.45348 8.73368C9.75687 8.53974 12.4563 6.79142 12.5306 6.79142C12.6496 6.79142 12.7237 6.86168 12.7237 6.98448C12.7237 7.11455 12.4731 7.24374 12.31 7.34332C11.2848 7.9681 10.26 8.64919 9.24503 9.29719C9.18581 9.33726 9.07113 9.4229 8.98519 9.40984C8.88939 9.39503 5.94842 7.50561 5.41335 7.1909C5.33294 7.14358 5.23336 7.10032 5.23336 6.98448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2325_10313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.1143b38bc71f3c95fb053cb72a3019e1.svg";
export { ForwardRef as ReactComponent };